import { GLOBAL_PORTAL_ELEMENT_ID } from './consts';

const NEW_ALCHEMY_GLOBAL_PORTAL_ELEMENT_ID = 'alchemy-portal';

// exported for testing only
export const globalMountElements: Record<string, HTMLDivElement | null> = {};

const canUseDOM = !(typeof window !== 'object' || !document);

/**
 * Utility to return (or create) the mounting element for Cookbook portaled components.
 */
export const getPortalElement = (id?: string): HTMLDivElement | null => {
  if (!canUseDOM) return null;

  const existingElement = globalMountElements[String(id)];

  if (existingElement) {
    // ensure that the portal has correct position even if it was created
    // by an older version of this utility
    if (!existingElement.style.position) {
      existingElement.style.position = 'fixed';
      existingElement.style.insetInline = '0';
      existingElement.style.top = '0';
    }

    return existingElement;
  }

  const mountElement: HTMLDivElement | null =
    id === undefined
      ? document.querySelector(
          `#${GLOBAL_PORTAL_ELEMENT_ID}, #${NEW_ALCHEMY_GLOBAL_PORTAL_ELEMENT_ID}`,
        )
      : document.querySelector(`#${id}`);

  if (mountElement) {
    globalMountElements[String(id)] = mountElement;
    return mountElement;
  }

  const newMountElement = document.createElement('div');
  newMountElement.id = id ?? GLOBAL_PORTAL_ELEMENT_ID;

  newMountElement.setAttribute('role', 'region');
  // Fixed position is required for the portal so that overflowing content will not cause
  // the page to scroll. Note that because of this the content inside the portal can get
  // hidden if positioning is not handled correctly.
  newMountElement.style.position = 'fixed';
  // Setting `insetInline` is required for the elements inside the portal to be able to
  // scale freely in width.
  newMountElement.style.insetInline = '0';
  // Setting `top` ensures that the portal is at the top of the page. This solved an issue
  // with the menu positioning with `react-select`.
  newMountElement.style.top = '0';
  document.body.append(newMountElement);

  globalMountElements[String(id)] = newMountElement;

  return newMountElement;
};
